import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { AddRounded } from "@mui/icons-material";

function Header() {
  return (
    <Box
      height={64}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      px={3}
      py={2}>
      <Typography variant="h6">Users</Typography>
      {/* <Button variant="contained" color="primary" startIcon={<AddRounded />}>
        Invite Member
      </Button> */}
    </Box>
  );
}

export default Header;
